window.crypto || (window.crypto = window.msCrypto);

var t = function t() {
  var t;

  try {
    t = function () {
      for (var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 21, r = "", o = crypto.getRandomValues(new Uint8Array(t)); t--;) {
        var n = 63 & o[t];
        r += n < 36 ? n.toString(36) : n < 62 ? (n - 26).toString(36).toUpperCase() : n < 63 ? "_" : "-";
      }

      return r;
    }(36);
  } catch (r) {
    t = Date.now() + Math.random().toString(36).slice(2);
  }

  return t;
},
    r = t();

export { t as getPvId, r as pvId };